import { ProviderPlugin } from './thirdPartyLoader';
import mixpanelTracking from 'Utils/mixpanelTracking';
import { MeObject } from 'Jsx/ContextApis/AuthContext';

function initMixpanel({
  user,
  debug,
}: {
  user?: Pick<MeObject, 'isPremiumMember'>;
  debug: boolean;
}) {
  if (!window.APP_DEBUG) {
    window.mixpanel.init(window.MIX_PANEL_TOKEN);
  } else {
    window.mixpanel.init(window.MIX_PANEL_TOKEN_TEST, {
      debug,
    });
  }

  if (window.DISTINCT_ID) {
    window.mixpanel.identify(window.DISTINCT_ID);
  }
  const mixPanelOptions = {
    isLogged: !!user,
    hasMembership: user?.isPremiumMember === true,
    page: window.MIXPANEL_PAGE || 'Untracked page',
  };

  window.mixpanel.unregister('courseDetailNotification');
  window.mixpanel.register(mixPanelOptions);
}

function mixpanelProvider(): ProviderPlugin {
  return {
    initialize: () => {
      /* eslint-disable */
      window.getTrackVisibiltyMixpanel = function() {
        try {
          return localStorage.getItem('TRACKS_VISIBILITY');
        } catch (error) {
          console.error(
            'Error to get the track visibility mixpanel from localStorage',
          );
          return '';
        }
      };
      window.setTracksVisibility = function(trackVisibility) {
        if (trackVisibility) {
          localStorage.setItem('TRACKS_VISIBILITY', 1);
        } else {
          localStorage.removeItem('TRACKS_VISIBILITY');
        }
      };

      delete window.mixpanel;
      // prettier-ignore
      (function(f,b){if(!b.__SV){var a,e,i,g;window.mixpanel=b;b._i=[];b.init=function(a,e,d){function f(b,h){var a=h.split(".");2==a.length&&(b=b[a[0]],h=a[1]);b[h]=function(){b.push([h].concat(Array.prototype.slice.call(arguments,0)))}}var c=b;"undefined"!==typeof d?c=b[d]=[]:d="mixpanel";c.people=c.people||[];c.toString=function(b){var a="mixpanel";"mixpanel"!==d&&(a+="."+d);b||(a+=" (stub)");return a};c.people.toString=function(){return c.toString(1)+".people (stub)"};i="disable track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" "); for(g=0;g<i.length;g++)f(c,i[g]);b._i.push([a,e,d])};b.__SV=1.2;a=f.createElement("script");a.type="text/javascript";a.async=!0;a.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";e=f.getElementsByTagName("script")[0];e.parentNode.insertBefore(a,e)}})(document,window.mixpanel||[]);

      const TRACKS_VISIBILITY = window.getTrackVisibiltyMixpanel();

      fetch('/api/v2/graph/?query=%7Bme%7BisPremiumMember%7D%7D', {
        method: 'POST',
      })
        .then(response => response.json())
        .then(({ data }) => {
          initMixpanel({
            user: data?.me,
            debug: !!TRACKS_VISIBILITY,
          });

          if (window.mixpanelQueue && window.mixpanelQueue.length) {
            window.mixpanelQueue.forEach(args => {
              mixpanelTracking.track(...args);
            });
          }

          window.track = function() {
            mixpanelTracking.track(...arguments);
          };
        })
        .catch(() => {
          initMixpanel({ debug: !!TRACKS_VISIBILITY });

          if (window.mixpanelQueue && window.mixpanelQueue.length) {
            window.mixpanelQueue.forEach(args => {
              mixpanelTracking.track(...args);
            });
          }

          window.track = function() {
            mixpanelTracking.track(...arguments);
          };
        });
      /* eslint-enable */
    },
    loaded: () => {
      return !!window.mixpanel;
    },
  };
}

export default mixpanelProvider;
